export enum WebSocketEventType {
  NEW_NOTIFICATION = "new_notification",
  MESSAGE_STATUS_UPDATE = "message_status_update",
  NEW_CONVERSATION = "new_conversation",
  CONVERSATION_UPDATE = "conversation_update",
  NEW_MESSAGE = "new_message"
}

export interface WebSocketConnectionOptions {
  organizationId: string;
  platformURI: string;
}

export interface AuthenticationEventData {
  success: boolean;
  error: string;
}
